import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateWatermark } from '@modules/editor';
import { Rnd } from 'react-rnd';
import Typography from '@mui/material/Typography';

function WatermarkCanvas({ idx }) {
    const dispatch = useDispatch();
    const el = useSelector((state) => state.editor.watermarkList[idx]);

    const updateElement = (updatedData) => {
        dispatch(updateWatermark({ ...el, ...updatedData, index: idx }));
    };

    const handleClick = () => {
        dispatch(updateWatermark({ ...el, isEditing: true, index: idx }));
    };

    return (
        <Rnd
            size={el.type === 'text' ? { width: 'auto', height: 'auto' } : { width: el.width, height: el.height }}
            position={{ x: el.x, y: el.y }}
            style={{
                border: el.isEditing ? '2px dashed white' : 'none',
                zIndex: el.isEditing ? 999 : undefined
            }}
            onDragStop={(_, d) => updateElement({ x: d.x, y: d.y })}
            onResizeStop={(_, __, ref, ___, position) => {
                updateElement({
                    width: ref.offsetWidth,
                    height: ref.offsetHeight,
                    x: position.x,
                    y: position.y
                });
            }}
            bounds="parent"
            disableDragging={!el.isEditing}
            enableResizing={el.isEditing && el.type !== 'text'}
            enableUserSelectHack={false}
            onClick={handleClick}
        >
            <div style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
                {el.type === 'image' ? (
                    <img
                        draggable={false}
                        src={el.image || "https://mpvldhluuktv5373941.cdn.ntruss.com/logo/csms39_mdl_dev_logo.png"}
                        alt="Watermark"
                        style={{ width: '100%', height: '100%' }}
                    />
                ) : (
                    <Typography
                        style={{
                            color: el.color || '#ffffff',
                            fontSize: `${el.fontSize || 16}px`
                        }}
                    >
                        {el.text}
                    </Typography>
                )}
            </div>
        </Rnd>
    );
}

export default WatermarkCanvas;